import React from "react";
import './c79_highlighter.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {insertHtml} from "../../utils/dom";

class Highlighter extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentRender(data) {
        return (
                <div id="highlighter" {...insertHtml(data.content)} />
        )
    }
}

export default Highlighter;
